import React from "react";
import { MarineProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";

export const marineVisuals: Record<MarineProjectType, ProjectVisualsType> = {
  [MarineProjectType.Kelp]: {
    icon: <></>,
    pictogram: "",
  },
  [MarineProjectType.Seagrass]: {
    icon: <></>,
    pictogram: "",
  },
  [MarineProjectType.ProtectedAreas]: {
    icon: <></>,
    pictogram: "",
  },
  [MarineProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [MarineProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
